






































































import { Dictionary } from "lodash";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";
import { ApiMessage, TreatmentRequestsApi } from "../../../apis";
import MyDateTimePickerMobile from '../mobile/common/MyDateTimePickerMobile.vue';

@Component({
  components: { ValidationProvider, ValidationObserver, MyDateTimePickerMobile },
})
export default class StopTreatmentDialog extends Vue {
  @Prop({}) selectedTreatmentRequest: any;
  @Prop({ default: false }) value: Boolean;
  @Ref("observer") readonly observer!: InstanceType<typeof ValidationObserver>;

  isAddWeight = false;
  isManual = false;
  autoStopDate = "";
  reason = "";
  invalidMsgStartDate = null;

  mounted() {}

  get show() {
    this.isAddWeight = false;
    this.isManual = false;
    this.autoStopDate = "";
    this.reason = "";
    this.invalidMsgStartDate = null;
    return this.value;
  }

  set show(value) {
    if(this.observer) this.observer.reset();
    this.$emit("input", value);
  }

  get apiMessages(): Dictionary<ApiMessage[]> {
    return this.$store.getters.apiMessages;
  }

  @Watch("apiMessages", { deep: true })
  apiMessagesWatch(messages: Dictionary<ApiMessage[]>) {
    this.$util.showApiError(messages, this.observer);
  }

  onChangeStartImmediately(val) {
    if (val) {
      this.autoStopDate = null;
      this.invalidMsgStartDate = "";
    }
  }

  async onSubmit() {
    const isValidDate = this.doCheckValidDate();
    const isValid =
      await this.observer.validate() && isValidDate;
    if (!isValid) {
      this.$util.goToErrorField(this.observer);
      return;
    }
    this.$util.showLoading();
    try {
      await new TreatmentRequestsApi().stopTreatmentRequest({
        id: this.selectedTreatmentRequest._id,
        putStopTreatmentRequestRequest: {
          isTicked: this.isAddWeight,
          immediately: !this.isManual,
          autoStopDate: !this.autoStopDate
            ? ""
            : this.$moment(this.autoStopDate, "YYYY-MM-DD HH:mm")
                .utc()
                .format("YYYY-MM-DD HH:mm"),
          reason: this.reason
        },
      });
      this.submitted();
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }

  doCheckValidDate(): boolean {
    if (this.isManual) return true;
    const autoStopDate = this.$moment(this.autoStopDate);
    const currentDate = this.$moment(new Date());
    if (autoStopDate < currentDate) {
      this.invalidMsgStartDate = this.$t("message.auto_stop_invalid");
      return false;
    }
    this.invalidMsgStartDate = "";
    return true;
  }

  onCancel() {
    this.show = false;
  }

  submitted() {
    this.$emit("submitted", true);
  }
}
